import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import UICard from "../UICard";
import { clx } from "../../../utils/Helpers";
import "./UIFormSectionCard.scss";

const UIFormSectionCard = ({ title, action, children, className, contentSx, ...props }) => (
  <UICard
    className={clx("ui-form-section-card", className)}
    contentSx={{
      display: "flex",
      flexDirection: "column",
      gap: "var(--space-20)",
      padding: "var(--space-24)",
      "&:last-child": { paddingBottom: "var(--space-24)" },
      ...contentSx,
    }}
    {...props}
  >
    {(title != null || action != null) && (
      <Box className="ui-form-section-card__header">
        {title != null && (
          <Typography
            sx={{
              fontFamily: '"Outfit", sans-serif',
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "24px",
              letterSpacing: 0,
              color: "var(--color-Side-bar-gradient-start, #31237D)",
            }}
          >
            {title}
          </Typography>
        )}
        {action != null && action}
      </Box>
    )}
    {children}
  </UICard>
);

UIFormSectionCard.propTypes = {
  title: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  contentSx: PropTypes.object,
};

UIFormSectionCard.defaultProps = {
  title: undefined,
  action: undefined,
  children: null,
  className: "",
  contentSx: undefined,
};

export default UIFormSectionCard;
